import { ECOM_STATUS } from '@/util/orders'

export const EDITABLE_STATUSES = [ECOM_STATUS.NEW, ECOM_STATUS.ACCEPTED, ECOM_STATUS.CONFIRMED]
export const COMMENT_EDITABLE_STATUSES = [
  ECOM_STATUS.DELIVERED,
  ECOM_STATUS.CANCELED,
  ECOM_STATUS.REJECTED,
  ECOM_STATUS.ERROR,
]
